// Если нужны какие-то константы, а их тут нет, то берите название отсюда:
// https://github.com/kabirbaidhya/keycode-js/blob/master/mod.ts

// Key code constants
// Available values for `KeyboardEvent.code` attribute.

export const VALUE_ENTER = 'Enter';
export const VALUE_ESCAPE = 'Escape';
export const VALUE_SPACE = ' ';
export const VALUE_PAGE_UP = 'PageUp';
export const VALUE_PAGE_DOWN = 'PageDown';
export const VALUE_END = 'End';
export const VALUE_HOME = 'Home';
export const VALUE_LEFT = 'ArrowLeft';
export const VALUE_UP = 'ArrowUp';
export const VALUE_RIGHT = 'ArrowRight';
export const VALUE_DOWN = 'ArrowDown';
